import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/store";
// import reportWebVitals from "./reportWebVitals";
import "assets/css/material-dashboard-react.css?v=1.10.0";
import "../src/assets/fonts/poppins/poppins.css";
import App from "./App";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import { createRoot } from "react-dom/client";

let persistor = persistStore(store);
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
);